module.exports = __webpack_public_path__ + "img/null.a75723b3.png";